<div class="demographics-container" *ngIf="isVisibleChart">
  <div class="row">
    <div class="col-sm-6 justify-padding-right">
      <div class="chart-container gender-chart">
        <achoo-pie-chart
          [chartData]="genderChartData"
          [chartTitle]="'INFLUENCER.CHART.GENDER' | translate"
          [height]="pieHeight"
          [pieCenter]="pieCenter"
          [pieSize]="pieSize"
          [pieInnerSize]="pieInnerSize"
          [titleStyling]="pieTitleStyling"
          [titleTooltip]="'info_box.influencer.gender' | translate"
          [listLegendPlaceholder]="['Male', 'Female']"
          [legend]="pieLegend">
        </achoo-pie-chart>
      </div>
    </div>
    <div class="col-sm-6 justify-padding-left">
      <div class="chart-container country-chart">
        <achoo-pie-chart
          [chartData]="countryChartData"
          [chartTitle]="'INFLUENCER.CHART.COUNTRIES' | translate"
          [height]="pieHeight"
          [pieCenter]="pieCenter"
          [pieSize]="pieSize"
          [pieInnerSize]="pieInnerSize"
          [titleStyling]="pieTitleStyling"
          [legend]="pieLegend"
          [listLegendPlaceholder]="['Demark', 'UAE', 'United State', 'United Kingdom']"
          [titleTooltip]="'info_box.influencer.countries' | translate">
        </achoo-pie-chart>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12">
      <div class="chart-container">
        <gender-per-age-chart [chartData]="genderPerAgeChart" [maxPercent]="genderPerAgeChartMaxPercent"></gender-per-age-chart>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-6 justify-padding-right">
      <div class="chart-container audience-interest-chart">
        <achoo-pie-chart
          [chartData]="audienceInterestChartData"
          [chartTitle]="'INFLUENCER.CHART.AUDIENCE_INTERESTS' | translate"
          [height]="pieHeight"
          [pieCenter]="pieCenter"
          [pieSize]="pieSize"
          [pieInnerSize]="pieInnerSize"
          [titleStyling]="pieTitleStyling"
          [forPayingUser]="true"
          [listLegendPlaceholder]="['Technology', 'Apparel', 'Media', 'Travel', 'Automotive']"
          [titleTooltip]="'info_box.influencer.audience_interests' | translate"
          [legend]="pieLegend">
        </achoo-pie-chart>
      </div>
    </div>
    <div class="col-sm-6 justify-padding-left">
      <div class="chart-container language-chart">
        <achoo-pie-chart
          [chartData]="nativeLanguageChartData"
          [chartTitle]="'INFLUENCER.CHART.NATIVE_LANGUAGES' | translate"
          [height]="pieHeight"
          [pieCenter]="pieCenter"
          [pieSize]="pieSize"
          [pieInnerSize]="pieInnerSize"
          [titleStyling]="pieTitleStyling"
          [forPayingUser]="true"
          [listLegendPlaceholder]="['English', 'Danish', 'Norwegian', 'Swedish', 'French']"
          [titleTooltip]="'info_box.influencer.audience_lang' | translate"
          [legend]="pieLegend">
        </achoo-pie-chart>
      </div>
    </div>
  </div>
  <div class="row d-none d-sm-block">
    <div class="col-sm-12">
      <div class="chart-container">
        <div class="title">{{'INFLUENCER.CHART.BRAND_AFFINITY' | translate}}</div>
        <div class="brand-list" *ngIf="!isFreeUser || isAdmin">
          <span class="badge brand" *ngFor="let item of brandAffinityChartData">{{item.name}}</span>
        </div>
        <div class="brand-list" *ngIf="isFreeUser && !isAdmin">
          <span class="badge brand placeholder" *ngFor="let item of placeholderItems; let i = index"
                [ngClass]="{
                  'super-short-item': i % 6 === 0,
                  'normal-item': i % 6 === 1,
                  'long-item': i % 6 === 2,
                  'medium-item': i % 6 === 3,
                  'short-item': i % 6 === 4,
                  'huge-item': i % 6 === 5
                  }">
          </span>
        </div>
      </div>
    </div>
    <div class="message-popup freemium" *ngIf="isFreeUser && !isAdmin">
      <div class="title">{{fallbackTitle}}</div>
      <div>{{fallbackMessage}}</div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-demographics/influencer-demographics.component.html